import DataCenterValue from "./datacenter-value";
import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function filteredSelectRenderer({
  obj,
  value,
  isOldValue,
}: RenderProps) {
  let parsedValue: string[] = [];
  if (Array.isArray(value)) {
    parsedValue = value;
  } else if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        parsedValue = parsed;
      } else if (typeof parsed === "string") {
        parsedValue = parsed.split(/;\s*|,\s*/);
      } else {
        parsedValue = [value];
      }
    } catch {
      parsedValue = value.split(/;\s*|,\s*/);
    }
  }

  parsedValue = parsedValue
    .flatMap((v) =>
      typeof v === "string" ? v.split(/;\s*|,\s*/).map((s) => s.trim()) : v,
    )
    .filter(Boolean);

  if (parsedValue.length === 0) {
    return <ValueDisplay isOldValue={isOldValue}>—</ValueDisplay>;
  }

  const levels =
    (obj.config?.levels as Array<{
      table: string;
      display_column: string;
      source: string;
    }>) || [];

  return (
    <p className="break-normal whitespace-pre-wrap text-size-body">
      {parsedValue.map((val, idx) => {
        const level = levels[idx];
        if (!level) return null;
        const isLast = idx === parsedValue.length - 1;
        return (
          <span key={`${val}-${idx}`}>
            <DataCenterValue
              table_name={level.table}
              column_name={level.display_column}
              table_source={level.source}
              value={val}
              oldValue={isOldValue}
            />
            {!isLast && ", "}
          </span>
        );
      })}
    </p>
  );
}
